import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01d0b31e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-auto container position-absolute" }

import { useRoute } from 'vue-router'
import { getMessage } from '@/constants/messageCode.ts'
import { ref, onMounted } from 'vue'
import ErrorMessage from '@/components/error-message'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const message = ref<string>('')
onMounted(() => {
  message.value = route.query?.message_code
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (message.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 0,
          title: _unref(getMessage)(message.value)
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})